/**
 * flow contents
 */
const HELLOPANDA_FLOW = {
  init: function() {

    // flow-block 요소를 찾기
    const flowBlocks = document.querySelectorAll('.flow-block');

    flowBlocks.forEach(flowBlock => {
      // flow-block-track 자식 요소를 찾기
      const trackElements = flowBlock.querySelectorAll('.flow-block-track');

      trackElements.forEach(trackElement => {
        // track 요소 복사
        const copiedTrack = trackElement.cloneNode(true);
        copiedTrack.setAttribute('aria-hidden', 'true'); // aria-hidden 속성 설정

        // flow-block의 같은 레벨에 복사한 track 추가
        flowBlock.appendChild(copiedTrack);
      });
      
      flowBlock.classList.add('flow-block-ready');
    });

  }
};
HELLOPANDA_FLOW.init();